import { ApiClient } from 'jsonapi-react'
import { GraphitiPlugin } from 'jsonapi-react-plugin-graphiti'
import env from '../env'
import { format, parseISO } from 'date-fns'

const getPhotoUrl = path => `${env.MEDIA_URL}/${path}`

export default function createClient(options) {
  return new ApiClient({
    ...options,
    plugins: [
      new GraphitiPlugin(),
    ],
    schema: {
      leads: {
        fields: {
          start_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
            serialize: date => (
              date ? format(date, 'yyyy-MM-dd HH:mm:ss') : undefined
            )
          },
          end_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
            serialize: (date, attrs) => (
              date ? format(date, 'yyyy-MM-dd HH:mm:ss') : undefined
            )
          },
        },
        relationships: {
          address: 'addresses',
          contact: 'contacts',
          occasion: 'occasions',
        }
      },
      addresses: {
        fields: {
          street: {
            readOnly: true,
          }
        }
      },
      photos: {
        fields: {
          url: {
            resolve: (val, attrs) => getPhotoUrl(attrs.path)
          },
        },
        relationships: {
          subject: {
            polymorphic: true,
          }
        }
      },
      calendar_events: {
        fields: {
          start_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
          },
          end_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
          },
        }
      },
      events: {
        fields: {
          start_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
          },
          end_date: {
            resolve: date => (
              date ? parseISO(date) : undefined
            ),
          },
        }
      },
      market_listings: {
        relationships: {
          vehicle_features: {
            type: 'vehicle_features',
          },
          photos: {
            type: 'photos'
          }
        }
      },
      market_inquiries: {
        relationships: {
          listing: {
            type: 'market_listings'
          }
        }
      }
    }
  })
}
